export default __webpack_public_path__ + "static/blob2-ddd019f04d64a3b5cbd5fddec2d341d0.svg";